<template>
  <Transition>
    <div class="simple-modal" id="onload-popup" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="simple-modal-dialog" role="document">
        <div class="simple-modal-content">
          <!-- ÜST BAŞLIK (istersen doldurursun) -->
          <div class="simple-modal-header">
            <h5 class="simple-modal-title">
              <!-- Buraya istersen başlık koyabilirsin -->
               {{ kalem.genel.tarih }} Ana Evrak Seri - No : {{ kalem.genel.evrak }}             Evrak Seri - No : {{ kalem.genel.evrak2 }}

            </h5>
            <button
              type="button"
              class="simple-modal-close"
              @click="handleClose"
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <!-- GÖVDE -->
<div class="simple-modal-body">
  <div class="simple-table-wrapper">
    <table class="simple-table">
      <thead>
        <tr>
          <th scope="col">Kod</th>
          <th scope="col">İsim</th>
          <th scope="col">Miktar</th>
          <th scope="col">B.Fiyat</th>
          <th scope="col">İsk.Fiyat</th>
          <th scope="col">Toplam</th>
          <th scope="col">Vergi</th>
          <th scope="col">Tutar</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in kalem.kalem" :key="index">
          <td>{{ item.kod }}</td>
          <td>{{ $helper.ilkharfBuyuk(item.isim) }}</td>
          <td>{{ item.adet + " " + $helper.ilkharfBuyuk(item.birim) }}</td>
          <td>{{ $helper.parabirimi(item.birim_fiyat,'TL') }}</td>
          <td>{{ $helper.parabirimi(item.isk_birim_fiyat,'TL') }}</td>

          <td>
            {{ $helper.parabirimi(item.adet * item.birim_fiyat,'TL') }}
          </td>

          <td>{{ $helper.parabirimi(item.adet*item.vergi,'TL') }}</td>

          <td>
            {{
              $helper.parabirimi(
                item.adet * item.isk_birim_fiyat + item.vergi,'TL'
              )
            }}
          </td>
        </tr>
        <!-- toplamlara dokunmadım -->
        <tr>
          <td colspan="6"></td>
          <td>Ara Toplam</td>
          <td>
            {{ $helper.parabirimi(kalem.toplam.aratoplam,'TL') }}
          </td>
        </tr>
        <tr>
          <td colspan="6"></td>
          <td>İskonto 1</td>
          <td>{{ $helper.parabirimi(kalem.toplam.iskonto1,'TL') }}</td>
        </tr>
        <tr>
          <td colspan="6"></td>
          <td>İskonto 2</td>
          <td>{{ $helper.parabirimi(kalem.toplam.iskonto2,'TL') }}</td>
        </tr>
        <tr>
          <td colspan="6"></td>
          <td>Vergi</td>
          <td>{{ $helper.parabirimi(kalem.toplam.vergi,'TL') }}</td>
        </tr>
        <tr>
          <td colspan="6"></td>
          <td>Genel Toplam</td>
          <td>
            {{ $helper.parabirimi(kalem.toplam.geneltoplam,'TL') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    kalem: {
      type: Object,
    },
  },
    methods: {
    handleClose () {
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
.simple-modal {
  position: fixed;
  inset: 0;
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}

.simple-modal-dialog {
  max-width: 900px;
  width: 95%;
}

.simple-modal-content {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.25);
}

/* HEADER / CLOSE aynı kalsın */
.simple-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e5e5;
}

.simple-modal-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.simple-modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

/* Body yüksekliği ve scroll */
.simple-modal-body {
  padding: 10px;
  max-height: calc(100vh - 120px);
  overflow: auto;
}

/* Tabla wrapper: yatay scroll */
.simple-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

/* Tablo */
.simple-table {
  width: 100%;
  min-width: 600px; /* çok daralmasın, gerekirse yatay kaydırılır */
  border-collapse: collapse;
  font-size: 13px;
}

.simple-table th,
.simple-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
  text-align: left;
}

.simple-table thead tr:first-child td {
  background: #f8f9fa;
  font-weight: 600;
}

.simple-table thead tr:nth-child(2) th {
  background: #f1f3f5;
}

.simple-table tbody tr:nth-child(odd) {
  background: #fafafa;
}

/* Mobil / küçük ekran ince ayarları */
@media (max-width: 768px) {
  .simple-modal-dialog {
    max-width: 100%;
    width: 100%;
    margin: 0 8px;
  }

  .simple-modal-content {
    border-radius: 4px;
    max-height: 100vh;
  }

  .simple-modal-body {
    padding: 8px;
    max-height: calc(100vh - 90px);
  }

  .simple-table {
    font-size: 12px;
    min-width: 500px;
  }

  .simple-table th,
  .simple-table td {
    padding: 4px 6px;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/foy.vue